import { XHRRequestCanceler } from '../../../../Libs/xhr/XHRRequestCanceler';
import { Lazy } from '../../../Helpers/Lazy';
import { IoC } from '../../ServicesContainer';
import { BaseReduxService } from '../Api/BaseReduxService';
import {
    IQualificationDataService,
    QualificationDataServiceName,
} from '../../../DataServices/QualificationDataService';
import {
    CompagnonQualification,
    CompagnonQualificationListResponse,
} from '../../../Models/Qualifications/Qualification';

export interface IQualificationService {
    getCompagnonQualifications: (
        compagnonId: string,
        cts: XHRRequestCanceler
    ) => Promise<CompagnonQualificationListResponse>;

    updateCompagnonQualifications: (
        compagnonId: string,
        qualifications: Array<CompagnonQualification>,
        cts: XHRRequestCanceler
    ) => Promise<CompagnonQualificationListResponse>;
}

class QualificationService extends BaseReduxService implements IQualificationService {
    private readonly qualificationDataService: Lazy<IQualificationDataService>;

    constructor() {
        super();
        this.qualificationDataService = IoC.getLazy<IQualificationDataService>(
            QualificationDataServiceName
        );
    }

    public getCompagnonQualifications = async (compagnonId: string, cts: XHRRequestCanceler) => {
        try {
            const response = await this.qualificationDataService
                .value()
                .getCompagnonQualifications(compagnonId, cts);
            return Promise.resolve(response);
        } catch (err) {
            return Promise.reject(err);
        }
    };

    public updateCompagnonQualifications = async (
        compagnonId: string,
        qualifications: Array<CompagnonQualification>,
        cts: XHRRequestCanceler
    ) => {
        try {
            const response = await this.qualificationDataService
                .value()
                .updateCompagnonQualifications(
                    compagnonId,
                    {
                        compagnon_qualifications: qualifications.map((x) => ({
                            compagnon_id: x.compagnon_id,
                            qualification_id: x.qualification.id,
                            has_qualification: x.has_qualification,
                            options: x.options,
                            validity_date: x.validity_date,
                            pdf_file_id: x.pdf_file_id,
                            created_date: x.created_date,
                        })),
                    },
                    cts
                );
            return Promise.resolve(response);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}

const QualificationServiceName = 'QualificationService';
export { QualificationService, QualificationServiceName };
